import React from 'react';

export default function Nav() {
    return (
        <nav>
            <span className="brand">
                React SVG Drag and Drop
            </span>
        </nav>
    );
}